export class CreatePortalAdminRequest{
    agentEmail: string;
    iataCode: string;
    language: string;
}